(() => {
  angular.module('app').component('memberCardHubComponent', {
    templateUrl: require('./memberCardHub.component.html'),
    controller: MemberCardHubController,
    controllerAs: 'vm',
    bindings: {      
      employee: '<',
      permissions: '<',
      enums: '<',
      settings: '<'
    }
  });

  MemberCardHubController.$inject = [
    '$uibModal',];

  function MemberCardHubController(
    $uibModal,) 
  {
    const vm = this;

    vm.getUserInitial = getUserInitial;

    vm.checkProviderList = checkProviderList;
    vm.getInpatientGlHistory = getInpatientGlHistory;
    vm.getInsurerPlanDetails = getInsurerPlanDetails;

    function getUserInitial(user) {
      const fullName = (user.name || ' ').split(' ');
      let initial = '';
      for (let i = 0; i < fullName.length; i += 1) {
        if (fullName[i].length) {
          initial += fullName[i][0];
        }
      }

      if (initial && initial.length > 3) initial = `${initial[0]}`;
      return initial;
    }

    function checkProviderList(employeeId) {
      $uibModal.open({
        templateUrl: require('./insurers/providerListModal/providerList.modal.html'),
        controller: 'host.views.employees.providerListModal as vm',
        size: 'xl',
        backdrop: 'static',
        resolve: {
          employeeId() {
            return employeeId;
          },
        },
      });
    }

    function getInpatientGlHistory(employeeId, serviceType) {
      $uibModal.open({
        templateUrl: require('../inpatientGlHistory/inpatientGlHistory.modal.html'),
        controller: 'host.views.employees.inpatientGlHistory.inpatientGlHistoryModal as vm',
        backdrop: 'static',
        size: 'xl',
        resolve: {
          employeeId() {
            return employeeId;
          },
          serviceType() {
            return serviceType;
          },
        },
      });
    }

    function getInsurerPlanDetails(insurer) {
      $uibModal.open({
        templateUrl: require('./insurers/insurerPlanModal/insurerPlan.modal.html'),
        controller: 'host.views.employees.insurerPlanModal as vm',
        backdrop: 'static',
        size: 'lg',
        resolve: {
          insurer() {
            return insurer;
          }
        },
      });
    }
  }
  
})();